import { Calendar, MapPin, Users, Clock, Settings } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';

const eventos = [
  { id: 1, titulo: 'Congreso Anual CAO 2026', fecha: 'Noviembre 2026', lugar: 'Buenos Aires', tipo: 'Congreso' },
  { id: 2, titulo: 'Jornadas de Actualización', fecha: 'Abril 2026', lugar: 'Córdoba', tipo: 'Jornada' },
  { id: 3, titulo: 'Simposio Regional Norte', fecha: 'Junio 2026', lugar: 'Tucumán', tipo: 'Simposio' },
  { id: 4, titulo: 'Workshop de Cirugía', fecha: 'Marzo 2026', lugar: 'Rosario', tipo: 'Workshop' },
];

const Eventos = () => {
  return (
    <div className="space-y-6">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <div className="flex items-center gap-3">
          <Settings className="w-5 h-5 text-amber-600" />
          <div>
            <p className="font-medium text-amber-800">Módulo en configuración</p>
            <p className="text-sm text-amber-600">Eventos estará disponible próximamente. A continuación se muestra una vista previa.</p>
          </div>
        </div>
      </div>

      <div className="opacity-50 pointer-events-none select-none">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-500 mb-2">Eventos CAO</h1>
          <p className="text-gray-400">Calendario de congresos, jornadas y actividades</p>
        </div>

        <div className="grid gap-4">
          {eventos.map((evento) => (
            <Card key={evento.id} className="bg-gray-50 border-gray-200">
              <CardContent className="p-6">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div className="flex items-start gap-4">
                    <div className="p-3 bg-gray-200 rounded-lg">
                      <Calendar className="w-6 h-6 text-gray-400" />
                    </div>
                    <div>
                      <Badge className="mb-2 bg-gray-300 text-gray-600">{evento.tipo}</Badge>
                      <h3 className="text-lg font-semibold text-gray-500">{evento.titulo}</h3>
                      <div className="flex items-center gap-4 mt-2 text-gray-400 text-sm">
                        <span className="flex items-center gap-1"><Clock className="w-4 h-4" /> {evento.fecha}</span>
                        <span className="flex items-center gap-1"><MapPin className="w-4 h-4" /> {evento.lugar}</span>
                      </div>
                    </div>
                  </div>
                  <Button className="bg-gray-300 text-gray-500" disabled>Inscribirse</Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Eventos;
